










let index={
  swiperInit(){
    new Swiper('.zs_container', {
      autoplay: true,//可选选项，自动滑动
      slidesPerView:4,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    })
    
    new Swiper('.city_container', {
      autoplay: true,//可选选项，自动滑动
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
      }
    })
    new Swiper('.act_container', {
      autoplay: true,//可选选项，自动滑动
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  },
  videoInit(){
    TCPlayer("videoPlayerA", {
      fileID: "5285890797836928264",
      appID: "1259605108",
      autoplay: false
    });
    TCPlayer("videoPlayerB", {
      fileID: "5285890793928536056",
      appID: "1259605108",
      autoplay: false
    });
    TCPlayer("videoPlayerC", {
      fileID: "5285890794347649685",
      appID: "1259605108",
      autoplay: false
    });
    
    
    TCPlayer("videoPlayerE", {
      fileID: "5285890795380695554",
      appID: "1259605108",
      autoplay: false
    });
    TCPlayer("videoPlayerF", {
      fileID: "5285890800373751591",
      appID: "1259605108",
      autoplay: false
    });
    TCPlayer("videoPlayerG", {
      fileID: "5285890796911467115",
      appID: "1259605108",
      autoplay: false
    });
  },
  teacherTab(){
    var oTabB = document.getElementsByClassName("reason_tab");
    var oContentB = document.getElementsByClassName("reason_content");
  
    function addClass(elem, value) {
      if (!elem.className) {
        elem.className = value;
      } else {
        var newClassName = elem.className;
        newClassName += " ";
        newClassName += value;
        elem.className = newClassName;
      }
    }
  
    function deleteClass(elem, value) {
      var newClassName = elem.className;
  
      if (newClassName.indexOf(value)) {
        elem.className = newClassName.replace(value, " ");
      }
    }
  
    for (var i = 0, len = oTabB.length; i < len; i++) {
      oTabB[i].index = i;
  
      oTabB[i].onmouseover = function () {
        var This = this;
  
        for (var j = 0; j < len; j++) {
          deleteClass(oTabB[j], "activeTabNew");
          deleteClass(oContentB[j], "activeNew");
        }
  
        addClass(This, "activeTabNew");
        addClass(oContentB[This.index], "activeNew");
      };
    }
  },
  booksTab(){
    $(".tab-box .tab").hover(function () {
      $(this).addClass("red-bgc").siblings().removeClass("red-bgc");
      $(".books .pic-content").eq($(this).index()).show().siblings().hide();
    });
  },
  select(){
    $(".submit_select .submit_input").click(function(e){
      e.stopPropagation()
      $(this).next().toggleClass("show")
    })
    $("body").click(function(){
      $(".submit_select_box").removeClass("show")
    })
    $(".select_course .submit_select_item").click(function(){
      let _this=$(this)
      _this.parent().prev().text(_this.text())
      $(".course_input").val(_this.text())
    })
    $(".select_city .submit_select_item").click(function(){
      let _this=$(this)
      _this.parent().prev().text(_this.text())
      $(".city_input").val(_this.text())
    })
    $(".submit_close").click(function(){
      $(".submit_box").hide()
    })
  },
  other(){
    $(".goSchool").click(function(){
      $("html,body").animate({
        scrollTop:$(".school_map").offset().top
    }, 500);
    })
  },
  dialogSubmit(){
    $(".dialog_submit_select .dialog_input").click(function(e){
      e.stopPropagation()
      let _this=$(this)
      $(".dialog_submit_selectBox").hide()
      _this.next().show()
    })
    $("body").click(function(){
      $(".dialog_submit_selectBox").hide()
    })
    $(".dialog_city .dialog_submit_selectItem").click(function(){
      let _this=$(this)
      $(".dialog_city").val(_this.text())
      $(".dialog_city .dialog_input").text(_this.text())
    })
    $(".dialog_course .dialog_submit_selectItem").click(function(){
      let _this=$(this)
      $(".dialog_course").val(_this.text())
      $(".dialog_course .dialog_input").text(_this.text())
    })
    $(".dialog_close").click(function(){
      $(".dialog_submit").hide()
    })
    $(".dialog_show").click(function(){
      // course_st
      if($(this).hasClass('adv_sign')){
        $(".dialog_2").show()
      }else{
        $(".dialog_1").show()
      }
    })

    $('.dialog_1').listenForm({
      contentName: '暑假班pc弹出表单',
      submitTarget: '.dialog_submit_1',
      courseRequired: true,
      cityRequired: true,
      successFun: function successFun() {
        $(".alert-test").show();
      }
    });
    $('.dialog_2').listenForm({
      contentName: '暑假班pc弹出表单',
      submitTarget: '.dialog_submit_2',
      courseRequired: true,
      cityRequired: true,
      isMsg: true,
      smsInfo: '【新航道】新航道烤鸭大礼包领取链接: https://pan.baidu.com/s/1Fm84dZaGjzO8Twu-BL-m9A 提取码: jsen 复制这段内容后打开百度网盘手机App，操作更方便哦。',
      successFun: function successFun() {
        $(".alert-bg").show();
      }
    });
    $(".alert-icon").click(function () {
      $(".common-alert").hide();
    }); // 隐藏弹框
  },
  init(){
    this.swiperInit()
    this.videoInit()
    this.teacherTab()
    this.booksTab()
    this.select()
    this.other()
    this.dialogSubmit()
  }
}

index.init()
$('.submit_box').listenForm({
  contentName:'暑假班pc底部悬浮表单',
  submitTarget: '#submit_btn',
  courseRequired: true,
  cityRequired: true
});

// let arr=[
//   {"name":"北京","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://tb.53kf.com/code/client/7777c54fa432dd07008074670174407c7/3#yiqing"},
//   {"name":"上海","discount":"报名暑假班 每满5000减500元！","url":"https://chat2440.talk99.cn/chat/chat/p.do?g=10066569&md=2&c=20002126&v=217505cbcf0145ee1488025a287a5168&u=217505cbcf0145ee1488025a287a5168&f=10090643&site=0&p0=http%3A%2F%2Fsh.xhd.cn%2Ftopic%2FSSAT%2F&ct=1&lang=sc&refer=&loc=http%3A%2F%2Fsh.xhd.cn%2Ftopic%2FSSAT%2F&_d=1584600245328"},
//   {"name":"武汉","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10068042&g=10066760"},
//   {"name":"南京","discount":"报名暑假班，前100名享500元现金红包，5万红包。。","url":"http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10068038&g=10066742&refer=gdljjtsjb"},
//   {"name":"杭州","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://chat6842.talk99.cn/chat/chat/p.do? _server=0&encrypt=1&c=20002143&f=10068171&g=10066808&refer=sem"},
//   {"name":"青岛","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://looyuoms7811.looyu.com/chat/chat/p.do?_server=0&encrypt=1&c=20000137&f=10038573&g=10043665&refer=jtppzq"},
//   {"name":"广州","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10068064&g=10066735&refer=gdlj&refer=jtppzq"},
//   {"name":"济南","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://looyuoms7622.looyu.com/chat/chat/p.do?_server=0&encrypt=1&c=20000240&f=10040850&g=10046096&refer=jtppzq"},
//   {"name":"长沙","discount":"暑假班预约正式开启，线上咨询可享专属学习大礼包","url":"http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10068018&g=10066731&refer=gdlj"},
//   {"name":"成都","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://tb.53kf.com/code/client/84c59b3f5bafa850ed4cacd089e946ec1/1"},
//   {"name":"西安","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://chat6843.talk99.cn/chat/chat/p.do?g=10066766&md=5&c=20002143&v=6bb4d49019d7ca19caec25a352605516&u=c065aac706b607c51af7ae929d7a0bce&f=10068062&site=15336&p0=http%3A%2F%2Fxa.xhd.cn%2F&ct=5&lang=sc&refer=&loc=http%3A%2F%2Fxa.xhd.cn%2F&_d=1581650613219"},
//   {"name":"石家庄","discount":"网络预报暑假班课程，尽享低折优惠","url":"http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10068020&g=10066739&refer=jthjbgdlj"},
//   {"name":"沈阳","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10073008&g=10069614&refer=gdljjtppzq"},
//   {"name":"福州","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10068059&g=10066736&refer=jtppzq"},
//   {"name":"泉州","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"http://looyuoms2431.looyu.com/chat/chat/p.do?g=10066794&md=2&c=20002143&refer=jtppzq"},
//   {"name":"郑州","discount":"预报暑假班：留学+课程 8折起，团报额外现金减免！","url":"http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10069626&g=10067737&refer=2020sjbjituan"},
//   {"name":"宁波","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://looyuoms7622.looyu.com/chat/chat/p.do? _server=0&encrypt=1&c=20000731&f=10050871&n=10168952&refer=sem"},
//   {"name":"合肥","discount":"暑期天天乐，乐享七重礼","url":"https://chat6843.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10068129&g=10066795&refer=gdljjtppzq"},
//   {"name":"唐山","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10069201&g=10067649&refer=gdljjtppzq"},
//   {"name":"淄博","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://looyuoms7622.looyu.com/chat/chat/p.do?_server=0&encrypt=1&c=20000240&f=10041647&g=10046102&refer=jtppzq"},
//   {"name":"烟台","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://looyuoms7622.looyu.com/chat/chat/p.do?_server=0&encrypt=1&c=20000421&f=10046119&g=10050784&refer=jtppzq"},
//   {"name":"深圳","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://chat6843.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10068052&g=10066747&refer=gdljjtppzq"},
//   {"name":"哈尔滨","discount":"暑假班免费试听  预报名享8折优惠","url":"http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10068026&g=10066734"},
//   {"name":"新航道在线","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://looyuoms2431.looyu.com/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10071726&g=10069138&refer=cjbjtppzq"},
//   {"name":"新航道留学","discount":"网络预报暑假班课程，尽享低折优惠","url":"http://bjlx.xhd.cn/chatlink.html"},
//   {"name":"墨尔本","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"http://www.xhdaz.com/"},
//   {"name":"南宁","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://www4c1.53kf.com/webCompany.php?kf_sign=TIwMzMTU2OgzOTEwMjYxOTU3NTk3MDA2NzIxMzY4NTY%253D&arg=10136856&style=1&jtppzq"},
//   {"name":"邯郸","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10069546&g=10067678&refer=XXjtppzq"},
//   {"name":"开封","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://chat6843.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10069626&g=10067737&refer=2017hjb&refer=jtppzq"},
//   {"name":"洛阳","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10069626&g=10067737&refer=2017hjb&refer=jtppzq"},
//   {"name":"厦门","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://chat6842.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10074044&g=10069988&refer=jtppzq"},
//   {"name":"昆明","discount":"网络预报暑假班课程，乐享9.5折优惠","url":"http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10071421&g=10068864&refer=XX"},
//   {"name":"大连","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"https://chat6843.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10095902&g=10079736&refer=gdljjtppzq"},
//   {"name":"太原","discount":"雅思托福暑假班，咨询送价值399预习资料包   ","url":" https://chat6843.talk99.cn/chat/chat/p.do?_server=0&encrypt=1&c=20002143&f=10096222&g=10079850&refer=gdljjtppzq"},
//   {"name":"常州","discount":"网络预报暑假班课程，尽享低折优惠","url":"http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10068038&g=10066742&refer=gdljjtsbks"},
//   {"name":"无锡","discount":"在线报名暑假班，优惠享不停，先到先得！","url":"http://chat.looyuoms.com/chat/chat/p.do?c=20002143&f=10068038&g=10066742&refer=gdljjtsbks"},
//   {"name":"绵阳","discount":"网络预报暑假班课程，尽享低折优惠","url":"https://tb.53kf.com/code/client/84c59b3f5bafa850ed4cacd089e946ec1/1"},
//  ]
// let html_str=''
//  for(let i=0;i<arr.length;i++){
//   if(i%6===0){
//     html_str+=`<div class="swiper-slide">
//     <div class="city_item">
//       <img src="./images/bj.png" alt="" class="city_img">
//       <div class="city_info">
//         <div class="city_name">${arr[i].name}学校</div>
//         <div class="city_discount">${arr[i].discount}</div>
//       </div>
//       <a href="${arr[i].url}" target="_blank" class="city_link">在线报名</a>
//     </div>`
//   }else if(i%6===5||i===arr.length-1){
//     html_str+=`<div class="city_item">
//     <img src="./images/bj.png" alt="" class="city_img">
//     <div class="city_info">
//       <div class="city_name">${arr[i].name}学校</div>
//       <div class="city_discount">${arr[i].discount}</div>
//     </div>
//     <a href="${arr[i].url}" target="_blank" class="city_link">在线报名</a>
//   </div>
// </div>`
//   }else{
//     html_str+=  `<div class="city_item">
//     <img src="./images/bj.png" alt="" class="city_img">
//     <div class="city_info">
//       <div class="city_name">${arr[i].name}学校</div>
//       <div class="city_discount">${arr[i].discount}</div>
//     </div>
//     <a href="${arr[i].url}" target="_blank" class="city_link">在线报名</a>
//   </div>`
//   }
//  }
//  $(".city_container .swiper-wrapper").append(html_str)